import styled from "styled-components";
import { Button as ButtonAntd } from "antd";
import { COLORS } from "../../../layout/theme";

export const AntdButton = styled(ButtonAntd)`
	min-width: 190px;
	height: ${(props) => (props.height ? `${props.height}px` : "40px")};
	border-radius: 10px;
	border: ${(props) =>
		props.$active ? "1px solid #e4e6ea" : "1px solid transparent"};
	background-color: ${(props) =>
		props.$active ? COLORS.White : "transparent"};
	color: ${(props) => (props.$active ? "#111827" : "#6b7280")};
	font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : "13px")};
	font-weight: 600;
	box-shadow: ${(props) =>
		props.$active
			? "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)"
			: "none"};

	&:hover,
	&:focus,
	&:active {
		background-color: ${(props) =>
			props.$active ? COLORS.White : "#f3f4f6"} !important;
		color: #111827 !important;
		border-color: ${(props) =>
			props.$active ? "#e4e6ea" : "transparent"} !important;
	}
`;

export const PageContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const PageHeaderBlock = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	gap: 20px;
	flex-wrap: wrap;
`;

export const TitleBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

export const PageTitle = styled.h1`
	margin: 0;
	font-size: 28px;
	font-weight: 700;
	line-height: 1.1;
	color: #111827;
	letter-spacing: -0.03em;
`;

export const PageSub = styled.p`
	margin: 0;
	font-size: 14px;
	color: #6b7280;
`;

export const ButtonContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 4px;
	background: #f8f9fa;
	border: 1px solid #e4e6ea;
	border-radius: 12px;
	flex-wrap: wrap;
`;

export const ContentShell = styled.div`
	background: ${COLORS.White};
	border: 1px solid #e4e6ea;
	border-radius: 16px;
	box-shadow:
		0 1px 3px rgba(0, 0, 0, 0.06),
		0 1px 2px rgba(0, 0, 0, 0.04);
	padding: 24px;

	@media only screen and (max-width: 768px) {
		padding: 16px;
	}
`;

export const ChildrenContainer = styled.div`
	width: 100%;
`;
